import { IGetPatrimonioCentroCustoByIdUseCase } from "../../../presentation/useCases/read/get_patrimonio_centro_custo_by_id_use_case";
import { PatrimonioCentroCustoModel } from "../../models/patrimonio_centro_custo";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetPatrimonioCentroCustoByIdUseCase
 */

export class GetPatrimonioCentroCustoByIdUseCase implements IGetPatrimonioCentroCustoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getPatrimonioCentroCustoById(
    idPatrimonioCentroCusto: number,
  ): Promise<PatrimonioCentroCustoModel> {
    return this.repository.getPatrimonioCentroCustoById(idPatrimonioCentroCusto);
  }
}
